import React, { useEffect, useState } from 'react';
import { KeyboardButton } from '../KeyboardButton/KeyboardButton';
import { KeyboardIconButton } from '../KeyboardIconButton/KeyboardIconButton';
import { Box } from '@mui/material';
import { Backspace, KeyboardCapslock, SpaceBar, SettingsBackupRestore, KeyboardReturn, Language, } from '@mui/icons-material';
export var OnScreenKeyboard = function (_a) {
    var onKeyPress = _a.onKeyPress, numbers = _a.numbers, firstLanguage = _a.firstLanguage, secondLanguage = _a.secondLanguage, secondLangLabel = _a.secondLangLabel, firstLangLabel = _a.firstLangLabel, keyboardWidth = _a.keyboardWidth, buttonSize = _a.buttonSize, labelLangButton = _a.labelLangButton, reverseButton = _a.reverseButton, singlyBack = _a.singlyBack, labelLetterButton = _a.labelLetterButton, betweenButtons = _a.betweenButtons, _b = _a.numbersColumns, numbersColumns = _b === void 0 ? '5' : _b, _c = _a.numbersRows, numbersRows = _c === void 0 ? '3' : _c;
    var _d = useState(true), isCapsLockOn = _d[0], setIsCapsLockOn = _d[1];
    var _e = useState(true), language = _e[0], setIsLanguage = _e[1];
    var _f = useState(true), isLettersMode = _f[0], setIsLettersMode = _f[1];
    useEffect(function () {
        var handleKeyUp = function (event) {
            if (event.key === 'caps') {
                setIsCapsLockOn(function (pr) { return !pr; });
            }
        };
        window.addEventListener('keyup', handleKeyUp);
        return function () {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    var layout = language ? firstLanguage : secondLanguage;
    var handleButtonClick = function (key) {
        if (key === 'caps') {
            setIsCapsLockOn(function (pr) { return !pr; });
            return;
        }
        if (isCapsLockOn) {
            setIsCapsLockOn(false);
        }
        onKeyPress(isCapsLockOn ? key.toUpperCase() : key);
    };
    var handleBackspaceClick = function () {
        onKeyPress('backspace');
    };
    var handleSpaceClick = function () {
        onKeyPress(' ');
    };
    var handleReverseClick = function () {
        onKeyPress('reverse');
    };
    var handleEnterClick = function () {
        onKeyPress('\n');
    };
    var handleLanguageClick = function (key) {
        if (key === 'language') {
            setIsLanguage(function (pr) { return !pr; });
        }
    };
    var handleLettersClick = function (key) {
        if (key === 'letters') {
            setIsLettersMode(function (prev) { return !prev; });
        }
    };
    return (React.createElement("div", { style: { width: keyboardWidth ? keyboardWidth : '900px' } },
        labelLetterButton ? (React.createElement(React.Fragment, null, !isLettersMode && (React.createElement(React.Fragment, null,
            numbers && singlyBack && (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'end' } },
                React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) }))),
            React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center' } },
                React.createElement(Box, { sx: {
                        display: 'inline-grid',
                        gridTemplateColumns: "repeat(".concat(numbersColumns, ", 1fr)"),
                        gridTemplateRows: "repeat(".concat(numbersRows, ", 1fr)"),
                        gap: '8px',
                        p: '8px',
                    } },
                    numbers &&
                        numbers.map(function (key) { return (React.createElement(KeyboardButton, { key: key, label: key, onClick: function () { return handleButtonClick(key); }, variant: "outlined", margin: betweenButtons })); }),
                    numbers && !singlyBack && (React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) })),
                    !numbers && (React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) })))))))) : (React.createElement(React.Fragment, null,
            numbers && singlyBack && (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'end' } },
                React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) }))),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: numbers ? '' : 'end',
                } },
                numbers &&
                    numbers.map(function (key) { return (React.createElement(KeyboardButton, { key: key, label: key, onClick: function () { return handleButtonClick(key); }, variant: "outlined", margin: betweenButtons })); }),
                numbers && !singlyBack && (React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) })),
                !numbers && React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) })),
            ' ')),
        labelLetterButton ? (React.createElement(React.Fragment, null, isLettersMode && (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: { display: 'flex', justifyContent: 'end' } },
                React.createElement(KeyboardButton, { onClick: handleBackspaceClick, children: React.createElement(Backspace, null) })),
            React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap' } }, layout &&
                layout.map(function (key) { return (React.createElement(KeyboardButton, { key: key, label: isCapsLockOn ? key.toUpperCase() : key, onClick: function () { return handleButtonClick(key); }, variant: "outlined", margin: betweenButtons })); })))))) : (React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap' } }, layout &&
            layout.map(function (key) { return (React.createElement(KeyboardButton, { key: key, label: isCapsLockOn ? key.toUpperCase() : key, onClick: function () { return handleButtonClick(key); }, variant: "outlined", margin: betweenButtons })); }))),
        React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
            React.createElement(Box, null,
                labelLangButton && (React.createElement(KeyboardButton, { label: language
                        ? "".concat(secondLangLabel ? secondLangLabel : null)
                        : "".concat(firstLangLabel ? firstLangLabel : null), onClick: function () { return handleLanguageClick('language'); }, startIcon: React.createElement(Language, null) })),
                labelLetterButton && (React.createElement(KeyboardButton, { label: isLettersMode ? '123' : 'ABC', onClick: function () { return handleLettersClick('letters'); } })),
                React.createElement(KeyboardIconButton, { onClick: function () { return handleButtonClick('caps'); }, color: isCapsLockOn ? 'success' : 'primary', children: React.createElement(KeyboardCapslock, null) })),
            React.createElement(KeyboardButton, { onClick: handleSpaceClick, width: "500px", variant: "outlined", children: React.createElement(SpaceBar, null) }),
            React.createElement(Box, null,
                reverseButton && (React.createElement(KeyboardButton, { onClick: handleReverseClick, children: React.createElement(SettingsBackupRestore, null) })),
                React.createElement(KeyboardButton, { onClick: handleEnterClick, 
                    // variant="outlined"
                    children: React.createElement(KeyboardReturn, null), 
                    // color={color}
                    size: buttonSize })))));
};
//# sourceMappingURL=OnScreenKeyboard.js.map